export default [
  {
    path: '/income_tax',
    name: 'income_tax',
    component: () => import('./IncomeTax.vue'),
    meta: {
      requiresAuth: true,
      name: 'Imposto de Renda',
    },
  },
]
